/* eslint-disable */
export default {
  searchPlaceholder: 'Haku...',
  refresh: 'Päivitä',
} as const;

// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
// @key: @#@"refresh"@#@ @source: @#@"Refresh"@#@
